/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }
}

window.customElements.define('cart-drawer', CartDrawer);

/* TwentySix cart: most recent first + one line per item (23.10).
   1. Shopify keeps a line where it was when the same item is added again, so a re-added item could sit at the bottom of the bag.
      Every successful add (product page, sticky bar, quick add, looks, add-ons) is remembered here, newest first, and the drawer
      list is ordered by it with CSS order, so it holds through every refresh of the drawer. The bag scrolls to the top after an add.
      Quantity +/- inside the bag never moves a line (it would jump away from under the finger).
   2. The product page and quick add send the hidden warehouse spot (_מיקום במחסן אתר), the look panels don't, and Shopify opens a
      new line when properties differ. Before every add the bag is read and an item already in it is sent with that line's exact
      properties, so the same item always joins its line. */
(function () {
  if (window.__tsRecentFirst) return;
  window.__tsRecentFirst = true;

  var STORE = 'ts-cart-recent';
  var recent = [];
  try { recent = JSON.parse(localStorage.getItem(STORE)) || []; } catch (e) { recent = []; }
  /* phones: the tap that adds to bag lands where the drawer's pay button then sits, and iOS leaves that button in its
     hover state (lighter, brown-looking). Hover effects in the bag apply only with a real mouse. */
  var BASE = '.ts-dr-items{display:flex;flex-direction:column}' +
    '@media (hover:none),(pointer:coarse){' +
      '.ts-drawer .ts-dr .ts-dr__btn:hover{opacity:1;color:#fff}' +
      '.ts-drawer .ts-dr .ts-qty__btn:hover{background:none}' +
      '.ts-drawer .ts-dr .ts-dli__remove:hover{color:var(--muted)}' +
      '.ts-drawer .ts-dr .ts-dr__cartlink:hover{opacity:1}' +
      '.ts-drawer .ts-dr .ts-dr__close:hover{opacity:1}' +
      '.ts-drawer .ts-dr .ts-dr-more__arrow:hover{border-color:var(--line-2)}' +
    '}' +
    /* short screens (iPhone mini/SE with Safari bars, landscape): the pay button stays pinned at the bottom and only the
       items scroll; the add-ons rail is left out there so the items get the room */
    '@media (max-height:600px){' +
      '.ts-drawer .ts-dr .ts-dr__inner{overflow:hidden}' +
      '.ts-drawer .ts-dr .ts-dr__body{flex:1 1 auto;min-height:0;overflow-y:auto}' +
      '.ts-drawer .ts-dr .ts-dr__inner:not(.is-empty) .ts-dr-more{display:none}' +
      '.ts-drawer .ts-dr .ts-dr__foot{padding-top:12px}' +
      '.ts-drawer .ts-dr .ts-dr__btn{height:48px;margin-top:12px}' +
      '.ts-drawer .ts-dr .ts-dr__links{margin-top:8px}' +
    '}';
  var styleEl = null;
  var pending = 0;

  function applyOrder() {
    if (!styleEl) {
      styleEl = document.createElement('style');
      styleEl.id = 'ts-dr-order';
      document.head.appendChild(styleEl);
    }
    var n = recent.length;
    styleEl.textContent = BASE + recent.map(function (id, i) {
      return '.ts-dr-items>[data-merge-list-item^="item-key:' + id + ':"]{order:' + (i - n) + '}';
    }).join('\n');
  }

  function remember(ids) {
    for (var i = ids.length - 1; i >= 0; i--) {
      var id = ids[i];
      var at = recent.indexOf(id);
      if (at > -1) recent.splice(at, 1);
      recent.unshift(id);
    }
    recent = recent.slice(0, 60);
    try { localStorage.setItem(STORE, JSON.stringify(recent)); } catch (e) {}
    applyOrder();
    pending = Date.now();
    [60, 400, 1000].forEach(function (t) { setTimeout(toTop, t); });
  }

  /* after an add the bag opens at the top, where the item now sits */
  function toTop() {
    if (!pending || Date.now() - pending > 4000) { pending = 0; return; }
    var drawer = document.querySelector('cart-drawer.ts-drawer');
    if (!drawer || !drawer.hasAttribute('open')) return;
    pending = 0;
    document.querySelectorAll('.ts-dr__body, .ts-dr__inner').forEach(function (el) {
      if (el.scrollTop > 0) el.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  function idsFrom(body) {
    var ids = [];
    function take(k, v) { if (k === 'id' || /^items\[\d+\]\[id\]$/.test(k)) ids.push(String(v)); }
    try {
      if (!body) return ids;
      if (typeof FormData !== 'undefined' && body instanceof FormData) body.forEach(function (v, k) { take(k, v); });
      else if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) body.forEach(function (v, k) { take(k, v); });
      else if (typeof body === 'string') {
        var s = body.trim();
        if (s.charAt(0) === '{') {
          var j = JSON.parse(s);
          if (j.id) ids.push(String(j.id));
          (j.items || []).forEach(function (it) { if (it && it.id) ids.push(String(it.id)); });
        } else {
          new URLSearchParams(s).forEach(function (v, k) { take(k, v); });
        }
      }
    } catch (e) {}
    return ids.filter(function (id) { return /^\d+$/.test(id); });
  }

  /* ---------- one line per item ---------- */
  function lineProps(cart, id) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].variant_id) === id) return items[i].properties || {};
    }
    return null;
  }

  function setFormProps(fd, prefix, props) {
    var drop = [];
    fd.forEach(function (v, k) { if (k.indexOf(prefix + '[') === 0) drop.push(k); });
    drop.forEach(function (k) { fd.delete(k); });
    Object.keys(props).forEach(function (k) { fd.append(prefix + '[' + k + ']', props[k]); });
  }

  /* returns a new body (string) or null when the body object was changed in place / needs nothing */
  function alignBody(body, cart) {
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      var single = body.get('id');
      var p = single && lineProps(cart, String(single));
      if (p) setFormProps(body, 'properties', p);
      for (var i = 0; i < 50; i++) {
        var vid = body.get('items[' + i + '][id]');
        if (!vid) break;
        var pi = lineProps(cart, String(vid));
        if (pi) setFormProps(body, 'items[' + i + '][properties]', pi);
      }
      return null;
    }
    if (typeof body === 'string' && body.trim().charAt(0) === '{') {
      var j = JSON.parse(body), changed = false;
      function fix(it) {
        var pp = it && it.id && lineProps(cart, String(it.id));
        if (!pp) return;
        if (Object.keys(pp).length) it.properties = pp; else delete it.properties;
        changed = true;
      }
      fix(j);
      (j.items || []).forEach(fix);
      return changed ? JSON.stringify(j) : null;
    }
    return null;
  }

  var isAdd = /\/cart\/add(\.js)?(\?|$)/;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  if (window.fetch) {
    var nativeFetch = window.fetch;
    var readCart = function () {
      var timer;
      return Promise.race([
        nativeFetch.call(window, root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; }),
        new Promise(function (res) { timer = setTimeout(function () { res(null); }, 1500); })
      ]).then(function (c) { clearTimeout(timer); return c; }, function () { clearTimeout(timer); return null; });
    };
    window.fetch = function (input, init) {
      var self = this, args = arguments, url = '';
      try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
      if (!isAdd.test(url.split('#')[0]) || !init || !init.body) return nativeFetch.apply(self, args);
      var ids = idsFrom(init.body);
      if (!ids.length) return nativeFetch.apply(self, args);
      return readCart().then(function (cart) {
        try {
          if (cart && cart.items && cart.items.length) {
            var nb = alignBody(init.body, cart);
            if (nb) init.body = nb;
          }
        } catch (e) {}
        var p = nativeFetch.call(self, input, init);
        p.then(function (r) { if (r && r.ok) remember(ids); }, function () {});
        return p;
      });
    };
  }
  if (window.XMLHttpRequest) {
    var open = XMLHttpRequest.prototype.open;
    var send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, url) { this.__tsUrl = String(url || ''); return open.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function (body) {
      try {
        if (this.__tsUrl && isAdd.test(this.__tsUrl.split('#')[0])) {
          var ids = idsFrom(body), xhr = this;
          if (ids.length) xhr.addEventListener('load', function () { if (xhr.status >= 200 && xhr.status < 300) remember(ids); });
        }
      } catch (e) {}
      return send.apply(this, arguments);
    };
  }

  applyOrder();
  document.addEventListener('on:cart-drawer:after-open', function () { setTimeout(toTop, 30); });
  document.addEventListener('on:cart:after-merge', function () { setTimeout(toTop, 30); });
})();
